/*
 * Project: TCI Project
 * Author: Savindu Thathsara
 * Version: 1.0.0
 * Date: 2024-01-14
 * Description: TCI website project
 */
jQuery(function ($) {
	$(document).ready(function () {
		// Contact us data send to the dashboard -  start
		$(document).on("forminator:form:submit:success", function (e) {
			const formElement = $(e.target).closest("form");
			const formId = formElement.data("form-id");

			if (formId === 4686) {
				console.log("Form submitted successfully");

				// Create a FormData object from the form element
				const formData = new FormData(formElement[0]);

				// Extract necessary fields
				const dataToSend = {
					platform_name: "Website",
					message: formData.get("textarea-1"),
					name: formData.get("name-1"),
					email: formData.get("email-1"),
					organization: formData.get("text-2"),
					job_title: formData.get("text-1"),
					subject: formData.get("select-1"), // Add Subject field
				};

				// Send data to the external API
				$.ajax({
					url: "https://dashboard.thecirculateinitiative.org/api/feedbacks",
					type: "POST",
					contentType: "application/json",
					data: JSON.stringify(dataToSend),
					headers: {
						Authorization:
							"Basic " +
							btoa("chamod@enfection.com:#)zdD>Al2i/Sf0x&FyN?GqVNA!7%55"),
					},
					success: function (response) {
						console.log("Data sent successfully:", response);
					},
					error: function (xhr, status, error) {
						console.error("Error sending data:", error);
					},
				});
			}
		});
		// Contact us data send to the dashboard -  end

		var laptopsInner = document.querySelectorAll("div.single_laptop_inner");

		for (const laptopInner of laptopsInner) {
			laptopInner.addEventListener("mouseover", (e) => {
				var imageHeight = e.target.offsetHeight;
				var laptopHeight = e.currentTarget.offsetHeight;
				var scrollHeight = imageHeight - laptopHeight;
				console.log(`${imageHeight} | ${laptopHeight} | ${scrollHeight}`);
				e.target.style.transform = "translate3d(0, -" + scrollHeight + "px, 0)";
			});
			laptopInner.addEventListener("mouseout", (e) => {
				e.target.style.transform = "translate3d(0, 0, 0)";
			});
		}

		// Laptop screan autoscroll - start
		(function () {
			var scrollingContent = $(".scrolling-contentt");
			var longWebpage = $(".long-webpagee");
			var containerHeight = scrollingContent.height();
			var contentHeight = longWebpage.height();
			var scrollSpeed = 2; // Adjust this value for increased scroll speed
			var scrollInterval;
			var isScrolling = false;

			var startScrolling = function () {
				if (!isScrolling) {
					isScrolling = true;
					scrollInterval = requestAnimationFrame(scrollWebpage);
				}
			};

			var stopScrolling = function () {
				isScrolling = false;
				cancelAnimationFrame(scrollInterval);
				if (!isHovered) {
					scrollToTop();
				}
			};

			var scrollWebpage = function () {
				var currentTop = parseInt(longWebpage.css("top")) || 0;
				var newTop = currentTop - scrollSpeed;

				if (newTop > -(contentHeight - containerHeight)) {
					longWebpage.css("top", newTop + "px");
					scrollInterval = requestAnimationFrame(scrollWebpage);
				} else {
					stopScrolling();
				}
			};

			var scrollToTop = function () {
				var currentTop = parseInt(longWebpage.css("top")) || 0;
				if (currentTop !== 0) {
					requestAnimationFrame(function () {
						longWebpage.css("top", 0);
					});
				}
			};

			var isHovered = false;
			$(".laptop-screen").hover(
				function () {
					isHovered = true;
					startScrolling();
				},
				function () {
					isHovered = false;
					stopScrolling();
				}
			);
		})();
		// Laptop screan autoscroll - end

		//  <-- Header function -->
		(function () {
			//  Header nav fixed function 🤗
			$(function () {
				const $navbar = $(".main-navigation"),
					$searchContainer = $(".search-container"),
					$body = $("body"),
					$searchBox = $("#search-box"),
					$searchForm = $(".search-form");

				let lastScrollTop = 0,
					navbarHeight = $navbar.outerHeight(),
					originalBodyPadRight = null;

				function getScrollbarWidth() {
					return window.innerWidth - document.documentElement.clientWidth;
				}

				function handleScroll() {
					const currentScroll = $(window).scrollTop();
					const isNavbarHidden =
						currentScroll > lastScrollTop && currentScroll > navbarHeight;

					$navbar
						.toggleClass("navbar-hidden", isNavbarHidden)
						.toggleClass("navbar-visible", !isNavbarHidden)
						.toggleClass("scrolled", currentScroll > navbarHeight);

					if (isNavbarHidden && $body.hasClass("search-backdrop")) {
						closeSearch();
					}

					lastScrollTop = currentScroll;
				}

				function toggleSearch(event) {
					event.preventDefault();
					$searchContainer.is(":visible") ? closeSearch() : openSearch();
				}

				function openSearch() {
					$(".main-navigation .offcanvas.show").offcanvas("hide");

					if (!$(".offcanvas.show").length) {
						originalBodyPadRight = $body.css("padding-right");
						const scrollbarWidth = getScrollbarWidth();
						if (scrollbarWidth) {
							$body.css("padding-right", scrollbarWidth + "px");
						}
					}

					$searchContainer.fadeIn(400);
					$body.addClass("search-backdrop").css("overflow", "hidden");
					$searchBox.focus();

					$(document).on("click.searchOutside", function (event) {
						if (
							!$(event.target).closest(".search-container, .search-box").length
						) {
							closeSearch();
						}
					});
				}

				function closeSearch() {
					$searchContainer.fadeOut(400, function () {
						if (!$(".offcanvas.show").length) {
							$body.removeClass("search-backdrop").css({
								overflow: "",
								"padding-right": originalBodyPadRight,
							});
						}
					});
					$(document).off("click.searchOutside");
				}

				$(window).on("scroll", handleScroll);
				$(".search-box").on("click", toggleSearch);
				$("#close-search").on("click", closeSearch);

				$searchForm.on("submit", function (event) {
					if ($searchBox.val().trim() === "") {
						event.preventDefault();
						return false;
					}
					closeSearch();
				});

				$searchContainer.on("click", function (event) {
					event.stopPropagation();
				});
			});

			// Add header searchbox function 🤗
			$(function () {
				var $searchBox = $("#search-box");
				var $resultList = $("#search-results");
				var $resultContainer = $("#search-results-container");
				var $resultCount = $("#result-count");
				var $loadMoreBtn = $("#load-more-btn");
				var allResults = [];

				function displayResults(limit) {
					$resultList.empty();

					if (allResults.length === 0) {
						$resultCount.text("No results found");
						$loadMoreBtn.hide();
						$resultList.append('<li class="no-result">No results found</li>');
					} else {
						var resultsToShow = limit ? allResults.slice(0, limit) : allResults;
						$resultCount.text("Results found: " + allResults.length);

						$.each(resultsToShow, function (i, item) {
							$resultList.append(
								'<li class="single-result"><span>' +
									item.type +
									' . </span><a class="link" href="' +
									item.permalink +
									'">' +
									item.title +
									'<i class="ri-external-link-line"></i></a></li>'
							);
						});

						// Show "Load More" button only if there are more than two results and it's the initial load
						$loadMoreBtn.toggle(
							allResults.length > 2 && typeof limit !== "undefined"
						);
					}
				}

				function fetchSearchResults(searchValue) {
					$.ajax({
						url: mytheme_ajax_object.ajaxurl,
						type: "POST",
						dataType: "json",
						data: {
							action: "mytheme_search",
							search_term: searchValue,
						},
						success: function (response) {
							allResults = response;
							displayResults(2); // Initially show only two results
							$resultContainer.show();
						},
					});
				}

				$searchBox.on("input", function () {
					var searchValue = $(this).val();

					if (searchValue.length < 3) {
						$resultContainer.hide();
						$loadMoreBtn.hide();
						return;
					}

					fetchSearchResults(searchValue);
				});

				$loadMoreBtn.on("click", function () {
					displayResults(); // Show all results
					$(this).hide();
				});
			});
		})();

		// <-- Carousels -->
		(function () {
			// Homepage hero optimized slider - start
			(function () {
				function initializeOptimizedCarousel({
					carouselSelector,
					prevButtonSelector = null, // Default to null if not provided
					nextButtonSelector = null, // Default to null if not provided
					dotContainerSelector,
					transitionSpeed = 500, // Default transition speed in milliseconds
					autoPlayDelay = 5000, // Default autoplay delay
					animationDelay = 200, // Default delay before starting the slide animation
				}) {
					var $carousel = $(carouselSelector);
					var $prevButton = $(prevButtonSelector);
					var $nextButton = $(nextButtonSelector);
					var $dotContainer = $(dotContainerSelector);
					var $items = $carousel.children(".carousel-item");
					var currentIndex = 0;
					var carouselInterval;
					var isTransitioning = false;

					// Set initial opacity for all items and then make the first item visible
					$items.css("opacity", "0").eq(0).css("opacity", "1");

					function updateCarousel(index) {
						if (isTransitioning || index === currentIndex) return; // Prevent action if current index is selected again
						isTransitioning = true;

						// Smooth transition to the new slide
						$items
							.eq(currentIndex)
							.animate({ opacity: 0 }, transitionSpeed, function () {
								$items
									.eq(index)
									.animate({ opacity: 1 }, transitionSpeed, function () {
										isTransitioning = false;
									});
								$items.removeClass("active").eq(index).addClass("active");
								currentIndex = index;
							});

						// Update dots
						if ($dotContainer.length) {
							$dotContainer
								.find(".dot")
								.removeClass("active")
								.eq(index)
								.addClass("active");
						}
					}

					// Initialize and bind click events to navigation dots
					function initDots() {
						$items.each(function (index) {
							$('<button aria-label="navigate">')
								.addClass("dot")
								.toggleClass("active", index === 0)
								.appendTo($dotContainer)
								.on("click", function () {
									setTimeout(() => updateCarousel(index), animationDelay); // Delay the update to allow for any ongoing transitions to complete
									restartAutoplay();
								});
						});
					}

					// Setup navigation buttons if they exist
					function setupNavigation() {
						if ($prevButton && $prevButton.length) {
							$prevButton.click(() => navigate(-1));
						}
						if ($nextButton && $nextButton.length) {
							$nextButton.click(() => navigate(1));
						}
					}

					function navigate(direction) {
						if (isTransitioning) return;
						var newIndex = currentIndex + direction;
						if (newIndex < 0) newIndex = $items.length - 1;
						else if (newIndex >= $items.length) newIndex = 0;
						updateCarousel(newIndex);
						restartAutoplay();
					}

					// Autoplay feature
					function startAutoplay() {
						carouselInterval = setInterval(() => navigate(1), autoPlayDelay);
					}

					function restartAutoplay() {
						clearInterval(carouselInterval);
						startAutoplay();
					}

					// Initialize carousel
					(function init() {
						initDots();
						setupNavigation();
						startAutoplay();
					})();
				}

				if ($(".home-page .hero-slider").length > 0) {
					initializeOptimizedCarousel({
						carouselSelector: ".hero .hero-slider",
						prevButtonSelector: ".hero .prev",
						nextButtonSelector: ".hero .next",
						dotContainerSelector: ".hero .carousel-dots",
						transitionSpeed: 300, // Adjust as needed
						autoPlayDelay: 4000, // Adjust as needed
						animationDelay: 100, // Adjust as needed
					});
				}
			})();
			// Homepage hero optimized slider - end

			//   PCIT - List card layout
			setTimeout(function () {
				jQuery(".list_card_carousel").each(function () {
					var $carousel = jQuery(this);
					var itemCount = $carousel.find(".item").length;

					console.log("Initializing carousel with " + itemCount + " items");

					$carousel.owlCarousel({
						loop: false, // ✅ Prevent infinite scroll
						margin: 20,
						nav: itemCount > 4,
						dots: false,
						autoplay: false,
						autoHeight: false,
						navText: [
							'<i class="fas fa-chevron-left"></i>',
							'<i class="fas fa-chevron-right"></i>',
						],
						responsive: {
							0: { items: 1 },
							576: { items: 2 },
							768: { items: 3 },
							992: { items: 3 },
							1200: { items: 4 },
						},
						onInitialized: function (event) {
							setEqualCardHeights($carousel);
						},
						onResized: function (event) {
							setTimeout(function () {
								setEqualCardHeights($carousel);
							}, 100);
						},
						onTranslated: function (event) {
							setEqualCardHeights($carousel);
						},
					});
				});

				function setEqualCardHeights($carousel) {
					var maxHeight = 0;
					var $activeItems = $carousel.find(".owl-item.active .single_card");

					$activeItems.css("height", "auto");
					$activeItems.find(".card-body").css("height", "auto");

					$activeItems.each(function () {
						var cardHeight = jQuery(this).outerHeight();
						if (cardHeight > maxHeight) {
							maxHeight = cardHeight;
						}
					});

					$activeItems.css("height", maxHeight + "px");

					$carousel
						.find(".owl-item .single_card")
						.css("min-height", maxHeight + "px");
				}

				jQuery(window).resize(function () {
					setTimeout(function () {
						jQuery(".list_card_carousel").each(function () {
							setEqualCardHeights(jQuery(this));
						});
					}, 300);
				});
			}, 500);

			// Homepage our approach - start
			if ($(".our-approach-mb-slider").length > 0) {
				$(".our-approach-mb-slider").owlCarousel({
					loop: true,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: true,
					responsive: {
						0: {
							items: 1,
							margin: 10,
							nav: false,
							dots: true,
						},
						600: {
							items: 1,
							margin: 15,
							nav: false,
							dots: true,
						},
						1000: {
							items: 1,
						},
					},
				});
			}
			// Homepage our approach - end

			// End Hero carousel -> home page
			if (window.innerWidth >= 992) {
				if ($(".our-approach-slider").length > 0) {
					var ourApproachOwl = $(".our-approach-slider");

					ourApproachOwl.owlCarousel({
						items: 1,
						loop: false,
						autoplay: false,
						dots: false,
						mouseDrag: false,
						smartSpeed: 450,
					});

					const approachElement = document.querySelector(".our-approach");
					if (approachElement) {
						const items = ourApproachOwl.find(".item").toArray();
						const itemHeight = window.innerHeight;
						const scrollHeightPerItem = itemHeight * 2; // Adjust as needed
						const totalScrollDistance =
							scrollHeightPerItem * (items.length - 1) + itemHeight; // Adjusted for last item

						let lastItemIndex = 0;
						let isTransitioning = false;

						gsap.timeline({
							scrollTrigger: {
								trigger: approachElement,
								start: "top top",
								end: "+=" + totalScrollDistance,
								pin: true,
								scrub: true,
								onUpdate: (self) => {
									const totalProgress = self.progress * items.length;
									const currentItemIndex = Math.min(
										Math.floor(totalProgress),
										items.length - 1
									);
									let currentItemProgress = totalProgress - currentItemIndex;

									// Adjust progress for last item
									if (currentItemIndex === items.length - 1) {
										currentItemProgress = Math.min(currentItemProgress, 1);
									}

									if (currentItemIndex !== lastItemIndex && !isTransitioning) {
										isTransitioning = true;

										// Fade out current item
										gsap.to(items[lastItemIndex], {
											opacity: 0,
											duration: 0.3,
											onComplete: () => {
												// Change carousel item
												ourApproachOwl.trigger("to.owl.carousel", [
													currentItemIndex,
													0,
												]);

												// Fade in new item
												gsap.fromTo(
													items[currentItemIndex],
													{ opacity: 0 },
													{
														opacity: 1,
														duration: 0.3,
														onComplete: () => {
															isTransitioning = false;
														},
													}
												);
											},
										});

										lastItemIndex = currentItemIndex;
									}

									// Scroll current item's long webpage
									const currentItem = items[currentItemIndex];
									const longWebpage =
										currentItem.querySelector(".long-webpage");
									if (longWebpage) {
										const maxScroll =
											longWebpage.offsetHeight - window.innerHeight;
										const scrollAmount = currentItemProgress * maxScroll;
										gsap.set(longWebpage, {
											y: -Math.min(scrollAmount, maxScroll),
										});
									}
								},
							},
						});

						// Refresh ScrollTrigger after window load
						window.addEventListener("load", function () {
							ScrollTrigger.refresh();
						});
					}
				}
			}

			// Check if ".our-approach-slider" exists
			if ($(".timeline-post-carousel").length > 0) {
				var syncedSecondary = true;

				// Initialize the main carousel with stage padding
				var sync1 = $(".timeline-post-carousel")
					.owlCarousel({
						items: 1,
						slideSpeed: 2000,
						nav: true,
						navText: [
							"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
							"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
						],
						dots: false,
						loop: false,
						autoplay: false, // Enable autoplay
						autoplayTimeout: 5000, // Set the time for each slide (5 seconds)
						responsiveRefreshRate: 200,
						responsive: {
							0: {
								items: 1,
							},
							600: {
								items: 1,
							},
							992: {
								items: 1,
							},
							1200: {
								items: 1,
							},
						},
					})
					.on("changed.owl.carousel", syncPosition);

				// Initialize the navigation carousel
				var sync2 = $(".timeline-post-nav-carousel")
					.on("initialized.owl.carousel", function (e) {
						// Find the index of the current item in sync1
						var current = sync1.find(".owl-item.active").index();
						// Add 'current' class to the corresponding item in sync2
						$(e.target).find(".owl-item").eq(current).addClass("current");
						updateFullItems($(e.target).find(".owl-item.active"));
					})
					.owlCarousel({
						items: 4, // Default number of items per page
						dots: false,
						nav: false,
						smartSpeed: 200,
						slideSpeed: 500,
						URLhashListener: true,
						startPosition: "URLHash",
						slideBy: 4,
						responsiveRefreshRate: 100,
						autoplay: false, // Enable autoplay
						autoplayTimeout: 5000, // Set the time for each slide (5 seconds)
						responsive: {
							0: {
								items: 2,
							},
							600: {
								items: 4,
							},
							992: {
								items: 4,
							},
							1200: {
								items: 4,
							},
						},
					})
					.on("changed.owl.carousel", syncPosition2);

				// Click event for sync2 items
				sync2.on("click", ".owl-item", function (e) {
					e.preventDefault();
					var number = $(this).index();
					sync1.data("owl.carousel").to(number, 300, true);
				});

				// Function to synchronize sync1 to sync2
				function syncPosition(el) {
					var current = el.item.index;
					var sync2Carousel = $(".timeline-post-nav-carousel");

					sync2Carousel
						.find(".owl-item")
						.removeClass("current")
						.eq(current)
						.addClass("current");
					updateNavigationCarousel(sync2Carousel, current);
				}

				// Function to synchronize sync2 to sync1
				function syncPosition2(el) {
					if (syncedSecondary) {
						var number = el.item.index;
						sync1.data("owl.carousel").to(number, 100, true);
					}
					updateFullItems($(this).find(".owl-item.active"));
				}

				// Function to update the navigation carousel
				function updateNavigationCarousel(sync2Carousel, current) {
					var onscreen = sync2Carousel.find(".owl-item.active").length - 1;
					var start = sync2Carousel.find(".owl-item.active").first().index();
					var end = sync2Carousel.find(".owl-item.active").last().index();

					if (current > end) {
						sync2Carousel.data("owl.carousel").to(current, 100, true);
					}
					if (current < start) {
						sync2Carousel
							.data("owl.carousel")
							.to(current - onscreen, 100, true);
					}
				}

				// Function to update the 'full' class on items
				function updateFullItems(items) {
					items.each(function () {
						var $item = $(this);
						$item.removeClass("full");
						if ($item.hasClass("active")) {
							$item.addClass("full");
						}
					});
				}

				// Manually trigger the syncPosition function on page load
				syncPosition({
					item: { index: sync1.find(".owl-item.active").index() },
				});
				// Start Timeline carousel -> Aboutus page
			}

			// Program and partnership single page full width image - start
			if ($(".pp_full_width_image_carousel").length > 0) {
				// Start Timeline carousel -> Aboutus page
				var syncedSecondary = true;

				// Initialize the main carousel with stage padding
				var sync1 = $(".pp_full_width_image_carousel")
					.owlCarousel({
						items: 1,
						slideSpeed: 2000,
						nav: false,
						dots: false,
						loop: true,
						autoplay: false, // Enable autoplay
						autoplayTimeout: 5000, // Set the time for each slide (5 seconds)
						responsiveRefreshRate: 200,
					})
					.on("changed.owl.carousel", syncPosition);

				// Initialize the navigation carousel
				var sync2 = $(".pp_full_width_image_content_carousel")
					.on("initialized.owl.carousel", function (e) {
						// Find the index of the current item in sync1
						var current = sync1.find(".owl-item.active").index();
						// Add 'current' class to the corresponding item in sync2
						$(e.target).find(".owl-item").eq(current).addClass("current");
						updateFullItems($(e.target).find(".owl-item.active"));
					})
					.owlCarousel({
						items: 1, // Default number of items per page
						navText: [
							"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
							"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
						],
						loop: true,
						dots: true,
						nav: true,
						smartSpeed: 200,
						slideSpeed: 500,
						slideBy: 4,
						responsiveRefreshRate: 100,
						autoplay: false, // Enable autoplay
						autoplayTimeout: 5000, // Set the time for each slide (5 seconds)
						responsive: {
							0: {
								items: 1,
								nav: false,
							},
							600: {
								items: 1,
								nav: false,
							},
							992: {
								items: 1,
							},
							1200: {
								items: 1,
							},
						},
					})
					.on("changed.owl.carousel", syncPosition2);

				// Prevent carousel from swiping when clicking on links
				sync1.on("drag.owl.carousel", function (event) {
					if ($(event.target).is("a")) {
						event.preventDefault();
					}
				});

				sync2.on("drag.owl.carousel", function (event) {
					if ($(event.target).is("a")) {
						event.preventDefault();
					}
				});

				// Click event for sync2 items
				sync2.on("click", ".owl-item", function (e) {
					if (!$(e.target).is("a")) {
						e.preventDefault();
						var number = $(this).index();
						sync1.data("owl.carousel").to(number, 300, true);
					}
				});

				// Add delay to distinguish between click and drag
				var isDragging = false;
				var dragStartTime;

				sync1.on("mousedown touchstart", ".owl-item", function () {
					isDragging = false;
					dragStartTime = new Date().getTime();
				});

				sync1.on("mousemove touchmove", ".owl-item", function () {
					isDragging = true;
				});

				sync1.on("mouseup touchend", ".owl-item", function (e) {
					var dragEndTime = new Date().getTime();
					if (!isDragging && dragEndTime - dragStartTime < 100) {
						if ($(e.target).is("a")) {
							window.location.href = $(e.target).attr("href");
						}
					}
				});

				// Repeat for sync2 if needed
				sync2.on("mousedown touchstart", ".owl-item", function () {
					isDragging = false;
					dragStartTime = new Date().getTime();
				});

				sync2.on("mousemove touchmove", ".owl-item", function () {
					isDragging = true;
				});

				sync2.on("mouseup touchend", ".owl-item", function (e) {
					var dragEndTime = new Date().getTime();
					if (!isDragging && dragEndTime - dragStartTime < 100) {
						if ($(e.target).is("a")) {
							window.location.href = $(e.target).attr("href");
						}
					}
				});

				// Function to synchronize sync1 to sync2
				function syncPosition(el) {
					var current = el.item.index;
					var sync2Carousel = $(".pp_full_width_image_content_carousel");

					sync2Carousel
						.find(".owl-item")
						.removeClass("current")
						.eq(current)
						.addClass("current");
					updateNavigationCarousel(sync2Carousel, current);
				}

				// Function to synchronize sync2 to sync1
				function syncPosition2(el) {
					if (syncedSecondary) {
						var number = el.item.index;
						sync1.data("owl.carousel").to(number, 100, true);
					}
					updateFullItems($(this).find(".owl-item.active"));
				}

				// Function to update the navigation carousel
				function updateNavigationCarousel(sync2Carousel, current) {
					var onscreen = sync2Carousel.find(".owl-item.active").length - 1;
					var start = sync2Carousel.find(".owl-item.active").first().index();
					var end = sync2Carousel.find(".owl-item.active").last().index();

					if (current > end) {
						sync2Carousel.data("owl.carousel").to(current, 100, true);
					}
					if (current < start) {
						sync2Carousel
							.data("owl.carousel")
							.to(current - onscreen, 100, true);
					}
				}

				// Function to update the 'full' class on items
				function updateFullItems(items) {
					items.each(function () {
						var $item = $(this);
						$item.removeClass("full");
						if ($item.hasClass("active")) {
							$item.addClass("full");
						}
					});
				}

				// Manually trigger the syncPosition function on page load
				syncPosition({
					item: { index: sync1.find(".owl-item.active").index() },
				});
				// End Timeline carousel -> Aboutus page
			}
			// Program and partnership single page full width image - end

			// Collaborators & supporters carousel - homepage start
			if ($(".collaborators-carousel").length > 0) {
				$(".collaborators-carousel").owlCarousel({
					loop: true,
					margin: 28,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: false,
					dots: false,
					autoplay: true,
					slideTransition: "linear",
					autoplayTimeout: 3500,
					autoplaySpeed: 3000,
					autoplayHoverPause: false,
					responsive: {
						0: {
							items: 3,
							margin: 10,
						},
						600: {
							items: 5,
							margin: 15,
						},
						1000: {
							items: 6,
						},
					},
				});
			}
			// Collaborators & supporters carousel - homepage end

			// Key users carousel - harmonized framework tools start
			if ($(".key-users-carousel").length > 0) {
				$(".key-users-carousel").owlCarousel({
					loop: true,
					margin: 32,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: false,
					dots: false,
					autoplay: true,
					autoplayTimeout: 4500,
					autoplaySpeed: 4000,
					autoplayHoverPause: false,
					responsive: {
						0: {
							items: 1,
							margin: 10,
						},
						600: {
							items: 3,
							margin: 15,
						},
						1000: {
							items: 5,
						},
					},
				});
			}
			// Key users carousel - harmonized framework tools end

			// Members carousel - About start
			if ($(".about-member-carousel").length > 0) {
				$(".about-member-carousel").owlCarousel({
					loop: true,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false,
					autoplayTimeout: 3500,
					autoplayHoverPause: true,
					responsive: {
						0: {
							items: 1,
							margin: 10,
						},
						600: {
							items: 1,
							margin: 15,
						},
						1000: {
							items: 5,
						},
					},
				});
			}
			// Members carousel - About end

			// Working group members carousel - About start
			if ($(".working-group-carousel").length > 0) {
				$(".working-group-carousel").owlCarousel({
					loop: true,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: false,
					dots: false,
					autoplay: true,
					slideTransition: "linear",
					autoplayTimeout: 3500,
					autoplaySpeed: 3000,
					autoplayHoverPause: false,
					responsive: {
						0: {
							items: 2,
							margin: 10,
						},
						600: {
							items: 2,
							margin: 15,
						},
						1000: {
							items: 5,
						},
					},
				});
			}
			// Working group members carousel - About end

			// Report carousel - Publications archive start
			if ($(".publications-archive .publication-report-carousel").length > 0) {
				$(".publications-archive .publication-report-carousel").owlCarousel({
					loop: false,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false,
					responsive: {
						0: {
							items: 1,
							margin: 10,
						},
						600: {
							items: 2,
							margin: 15,
						},
						1000: {
							items: 3,
						},
					},
				});
			}
			// Report carousel - Publications archive end

			// Videos carousel - Videos archive start
			if ($(".videos-archive .videos-report-carousel").length > 0) {
				$(".videos-archive .videos-report-carousel").owlCarousel({
					loop: false,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false,
					responsive: {
						0: {
							items: 1,
							margin: 10,
						},
						600: {
							items: 2,
							margin: 15,
						},
						1000: {
							items: 3,
						},
					},
				});
			}
			// Videos carousel - Videos archive end

			// Media coverage - archive start
			if ($(".media-coverage-archive .media-carousel").length > 0) {
				$(".media-coverage-archive .media-carousel").owlCarousel({
					loop: false,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: true,
					responsive: {
						0: {
							items: 2,
							margin: 10,
							dots: false,
							nav: true,
						},
						600: {
							items: 4,
							margin: 15,
							dots: true,
							nav: false,
						},
						1000: {
							items: 4,
						},
					},
				});
			}
			// Media coverage - archive end

			// Research and tools - realated resourches carosel - start
			if ($(".research_related_resources_carousel").length > 0) {
				$(".research_related_resources_carousel").owlCarousel({
					loop: false,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: true,
					responsive: {
						0: {
							items: 2,
							margin: 10,
						},
						600: {
							items: 4,
							margin: 15,
						},
						1000: {
							items: 4,
						},
					},
				});
			}
			// Research and tools - realated resourches carosel - end

			// Research and tools - resources carosel - start
			if ($(".research_resources_card_carousel").length > 0) {
				$(".research_resources_card_carousel").owlCarousel({
					loop: false,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false,
					responsive: {
						0: {
							items: 1,
							margin: 10,
							nav: false,
							dots: true,
						},
						600: {
							items: 2,
							margin: 15,
							nav: false,
							dots: true,
						},
						1000: {
							items: 3,
						},
					},
				});
			}
			// Research and tools - resources carosel carosel - end

			// Research and tools - testionials carosel - start
			if ($(".research_tools_testimonials_card_carousel").length > 0) {
				$(".research_tools_testimonials_card_carousel").owlCarousel({
					loop: false,
					margin: 22,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false, // disable autoplay
					responsive: {
						0: {
							items: 1,
							margin: 10,
							nav: false,
							dots: true,
						},
						600: {
							items: 2,
							margin: 15,
							nav: false,
							dots: true,
						},
						1000: {
							items: 3, // show 3 cards in carousel
						},
					},
				});
			}

			// Research and tools - resources testionials carosel - end

			// Programms and partnership carosel - start
			if ($(".pp_parters_carousel").length > 0) {
				$(".pp_parters_carousel").owlCarousel({
					loop: false,
					margin: 32,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: true,
					responsive: {
						0: {
							items: 3,
							margin: 10,
						},
						600: {
							items: 3,
							margin: 22,
						},
						1000: {
							items: 4,
						},
					},
				});
			}
			// Programms and partnership carosel - end

			// Annual report carosel - start
			if ($(".annual_covering_carousel").length > 0) {
				$(".annual_covering_carousel").owlCarousel({
					loop: false,
					margin: 32,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false,
					responsive: {
						0: {
							items: 1,
							margin: 10,
							nav: false,
							dots: true,
						},
						600: {
							items: 2,
							margin: 22,
							nav: false,
							dots: true,
						},
						1000: {
							items: 2,
						},
					},
				});
			}
			// Annual report carosel - end

			// Programms and partnership video carosel - start
			if ($(".video_gallery_card_carousel").length > 0) {
				$(".video_gallery_card_carousel").owlCarousel({
					loop: false,
					margin: 32,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: true,
					dots: false,
					autoplay: false,
					responsive: {
						0: {
							items: 1,
							margin: 10,
							dots: true,
							nav: false,
						},
						600: {
							items: 2,
							margin: 22,
							dots: true,
							nav: false,
						},
						1000: {
							items: 3,
						},
					},
				});
			}
			// Programms and partnership video carosel - end

			// Home page hero - start
			if ($(".hero_home_carousel").length > 0) {
				$(".hero_home_carousel").owlCarousel({
					loop: true,
					margin: 0,
					navText: [
						"<div class='prev-slide'><i class='ri-arrow-left-s-line'></i></div>",
						"<div class='next-slide'><i class='ri-arrow-right-s-line'></i></div>",
					],
					nav: false,
					dots: true,
					autoplay: true,
					autoplayTimeout: 6500,
					responsive: {
						0: {
							items: 1,
						},
						600: {
							items: 1,
						},
						1000: {
							items: 1,
						},
					},
				});
			}
		})();

		// <-- Other custom functions -->
		(function () {
			// PDF Download function - research and tools - start
			$(document).on("forminator:form:submit:success", function (e, response) {
				console.log("Form submitted successfully");
				console.log("Response:", response);

				// Trigger PDF download for any successful form submission
				downloadPDF();
			});

			function downloadPDF() {
				console.log("Attempting to download PDF");
				var downloadBtn = $("#pdfDownloadBtn");
				if (downloadBtn.length) {
					console.log("Download button found");
					console.log("Download URL:", downloadBtn.attr("href"));

					// Method 1: Trigger click event
					downloadBtn[0].click();
				} else {
					console.error("Download button not found");
				}
			}
			// PDF Download function - research and tools - end
			// Copy current page url - Event single page - start
			$(".copyLinkBtn").click(function () {
				var currentURL = window.location.href;
				var $tempInput = $("<input>").val(currentURL).appendTo("body").select();
				document.execCommand("copy");
				$tempInput.remove();

				// Show the badge
				var $badge = $(this).siblings(".copy-badge");
				$badge.fadeIn(300);

				// Hide the badge after 2 seconds
				setTimeout(function () {
					$badge.fadeOut(300);
				}, 1800);
			});
			// Copy current page url - Event single page - end
			// Homepage animate count function - start
			if ($(".our-impact").length > 0) {
				ScrollTrigger.create({
					trigger: ".our-impact",
					start: "top bottom",
					onEnter: () => animateCounts(),
					toggleActions: "play none none none",
				});
			}

			function animateCounts() {
				$(".count").each(function () {
					const $this = $(this);
					const target = parseInt($this.data("target"), 10); // Get the target value as an integer
					const hasPlus = $this.text().trim().endsWith("+"); // Check if the text ends with a +

					// Function to add commas to number
					function addCommas(num) {
						return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
					}

					// Animate from 0 to the target value
					let obj = { val: 0 }; // Object to animate
					gsap.to(obj, {
						val: target,
						duration: 1,
						ease: "power1.out",
						onUpdate: function () {
							$this.text(addCommas(Math.ceil(obj.val)));
						},
						onComplete: function () {
							if (hasPlus) {
								$this.text(addCommas(target) + "+"); // Append "+" if it was originally present
							}
						},
					});
				});
			}
			// Homepage animate count function - end

			// Image Optimizer
			function animateImages() {
				$(".optimized-img-wrapper img")
					.on("load", function () {
						$(this).animate({ opacity: 1 }, 500);
					})
					.each(function () {
						if (this.complete) {
							$(this).trigger("load");
						}
					});
			}
			// Call the function
			animateImages();

			// End Image Optimizer

			$(".social-share-btn").click(function (e) {
				e.preventDefault();
				var shareUrl = $(this).data("share-url");
				window.open(shareUrl, "social-popup", "height=600,width=600");
			});

			// Add blog page progress bar function start
			function createScrollProgressBar(progressBarId) {
				$(window).on("scroll", function () {
					var scrollPercentage =
						($(window).scrollTop() /
							($(document).height() - $(window).height())) *
						100;
					$(progressBarId).css("width", scrollPercentage + "%");
				});
			}
			// Knowledgebase single template
			createScrollProgressBar(".progressBar");
			// Add blog page progress bar function end
		})();

		// <-- Filter functions -->
		(function () {
			// Knowledge bank custom post archive page post filter functions - start
			/**
			 * Function: initializeTaxonomyFilter(options).
			 * Description: filter dunction.
			 * Returns: initializeTaxonomyFilter(options).
			 */

			function initializeTaxonomyFilter(options) {
				var postsPerPage = options.postsPerPage || 5;
				var visiblePages = options.visiblePages || 5;
				var urlUpdate =
					options.urlUpdate !== undefined ? options.urlUpdate : true;
				var ajaxAction =
					options.ajaxAction || "get_posts_by_multiple_taxonomies";
				var containerSelector = options.containerSelector || "#posts-container";
				var paginationSelector = options.paginationSelector || "#pagination";
				var taxonomySelector = options.taxonomySelector || ".taxonomy-select";
				var searchInputSelector =
					options.searchInputSelector || "#search-input";
				var sortOrderSelector = options.sortOrderSelector || ".sort-order";
				var clearFiltersSelector =
					options.clearFiltersSelector || ".clear-filters";
				var dateRangeEnable =
					options.dateRangeEnable !== undefined
						? options.dateRangeEnable
						: true;
				var getPostCount = options.getPostCount || ".unic-post-count";
				var dateRangeInputId = options.dateRangeInputId || "blog-date-range";

				var flatpickrInstance;

				// Date picker initialization
				if (dateRangeEnable) {
					var dateRangeElement = document.getElementById(dateRangeInputId);

					if (dateRangeElement) {
						flatpickrInstance = flatpickr(dateRangeElement, {
							mode: "range",
							dateFormat: "Y-m-d",
							onClose: function (selectedDates, dateStr, instance) {
								if (selectedDates.length === 2) {
									fetchPosts(1);
								}
								checkFiltersSelected();
							},
						});
					}
				}

				function checkFiltersSelected() {
					var filterSelected = false;
					$(taxonomySelector).each(function () {
						if ($(this).val() !== "all") {
							filterSelected = true;
						}
					});

					if ($(searchInputSelector).val() !== "") {
						filterSelected = true;
					}

					if (
						dateRangeEnable &&
						flatpickrInstance &&
						flatpickrInstance.selectedDates.length === 2
					) {
						filterSelected = true;
					}

					if (filterSelected) {
						$(clearFiltersSelector).show();
					} else {
						$(clearFiltersSelector).hide();
					}
				}

				function clearFilters() {
					$(taxonomySelector).val("all");
					$(searchInputSelector).val("");

					$(".taxonomy-list").each(function () {
						$(this).find(".list-item").removeClass("active");
						$(this).find(".list-item[data-term-id='all']").addClass("active");
					});

					if (dateRangeEnable && flatpickrInstance) {
						flatpickrInstance.clear();
					}
					updateActiveClassOnSelect();
					updateParentClassOnChildSelect();
					fetchPosts(1);
					checkFiltersSelected();
				}

				$(
					taxonomySelector +
						", " +
						searchInputSelector +
						", " +
						sortOrderSelector
				).on("change keyup", function () {
					checkFiltersSelected();
					fetchPosts(1);
				});

				$(clearFiltersSelector).on("click", function () {
					clearFilters();
				});

				function updateUrlWithFilters(selectedTerms, page) {
					if (urlUpdate && $(taxonomySelector).length > 0) {
						var params = $.param(selectedTerms) + "&page=" + page;
						history.pushState(null, null, "?" + params);
					}
				}

				function applyFiltersFromUrl() {
					var urlParams = new URLSearchParams(window.location.search);
					$(taxonomySelector).each(function () {
						var taxonomy = $(this).attr("id").replace("taxonomy-select-", "");
						if (urlParams.has(taxonomy)) {
							$(this).val(urlParams.get(taxonomy));
						}
					});
					var page = urlParams.get("page")
						? parseInt(urlParams.get("page"), 10)
						: 1;
					fetchPosts(page);
				}

				$(".taxonomy-list").on("click", ".list-item", function () {
					var $list = $(this).closest(".taxonomy-list");
					$list.find(".list-item").removeClass("active");
					$(this).addClass("active");
					updateParentClassOnChildSelect();
					checkFiltersSelected();
					fetchPosts(1);
				});

				function fetchPosts(page = 1) {
					var selectedTerms = {};
					var sortOrder = $(sortOrderSelector).val();

					var startDate = "";
					var endDate = "";
					var dateRange = "";

					if (dateRangeEnable && flatpickrInstance) {
						var selectedDates = flatpickrInstance.selectedDates;
						if (selectedDates.length === 2) {
							startDate = flatpickr.formatDate(selectedDates[0], "Y-m-d");
							endDate = flatpickr.formatDate(selectedDates[1], "Y-m-d");
							dateRange = startDate + " to " + endDate;
						}
					}

					$(taxonomySelector).each(function () {
						var taxonomy = $(this).attr("id").replace("taxonomy-select-", "");
						var term = $(this).val();
						if (term !== "all") {
							selectedTerms[taxonomy] = term;
						}
					});

					$(".taxonomy-list").each(function () {
						var taxonomy = $(this).attr("id").replace("taxonomy-list-", "");
						var activeItem = $(this).find(".list-item.active");
						var term = activeItem.data("term-id");
						if (term !== "all") {
							selectedTerms[taxonomy] = term;
						}
					});

					var searchKeyword = $(searchInputSelector).val();

					$(".loading-animation").fadeIn();

					function animatePostLoading(posts) {
						var delay = 0;
						posts.each(function () {
							jQuery(this)
								.css({ opacity: 0 })
								.delay((delay += 100))
								.fadeTo(250, 1);
						});
					}

					$.ajax({
						url: mytheme_ajax_object.ajaxurl,
						type: "POST",
						data: {
							action: ajaxAction,
							selectedTerms: selectedTerms,
							searchKeyword: searchKeyword,
							sortOrder: sortOrder,
							postsPerPage: postsPerPage,
							paged: page,
							date_range: dateRange,
						},
						success: function (response) {
							var data = JSON.parse(response);
							var $postsContainer = $(containerSelector);
							$postsContainer.hide().html(data.posts);

							$(".loading-animation").fadeOut();

							animatePostLoading($postsContainer.children());

							var delayTime = 0;
							$postsContainer.children().each(function () {
								$(this).delay(delayTime).fadeIn(300);
								delayTime += 250;
							});

							$(getPostCount).text(data.postCount);
							$postsContainer.show();

							if (data.totalPages > 1) {
								updatePagination(data.totalPages, page);
							} else {
								$(paginationSelector).hide();
							}

							if (urlUpdate) {
								updateUrlWithFilters(selectedTerms, page);
							}
						},
						error: function (jqXHR, textStatus, errorThrown) {
							console.error("Error fetching posts:", textStatus, errorThrown);
							$(".loading-animation").fadeOut();
						},
					});
				}

				function updatePagination(totalPages, currentPage) {
					var paginationHtml = "";
					var startPage = Math.max(
						1,
						currentPage - Math.floor(visiblePages / 2)
					);
					var endPage = Math.min(totalPages, startPage + visiblePages - 1);
					startPage = Math.max(
						1,
						Math.min(totalPages - visiblePages + 1, startPage)
					);

					if (currentPage > 1) {
						paginationHtml +=
							'<a href="#" class="page-num" data-page="' +
							(currentPage - 1) +
							'"><i class="ri-arrow-left-s-line"></i></a> ';
					}

					if (startPage > 1) {
						paginationHtml +=
							'<a href="#" class="page-num" data-page="1">1</a> ';
						if (startPage > 2) {
							paginationHtml += "<span>...</span> ";
						}
					}
					for (var i = startPage; i <= endPage; i++) {
						paginationHtml +=
							'<a href="#" class="' +
							(i === currentPage ? "active " : "") +
							'page-num" data-page="' +
							i +
							'">' +
							i +
							"</a> ";
					}
					if (endPage < totalPages) {
						if (endPage < totalPages - 1) {
							paginationHtml += "<span>...</span> ";
						}
						paginationHtml +=
							'<a href="#" class="page-num" data-page="' +
							totalPages +
							'">' +
							totalPages +
							"</a> ";
					}

					if (currentPage < totalPages) {
						paginationHtml +=
							'<a href="#" class="page-num" data-page="' +
							(currentPage + 1) +
							'"><i class="ri-arrow-right-s-line"></i></a>';
					}

					$(paginationSelector).html(paginationHtml).show();

					$(".page-num").on("click", function (e) {
						e.preventDefault();
						var page = $(this).data("page");
						fetchPosts(page);
					});
				}

				function updateActiveClassOnSelect() {
					$(taxonomySelector).each(function () {
						$(this).find("option").removeClass("active");
						$(this).find("option:selected").addClass("active");
					});
				}

				function updateParentClassOnChildSelect() {
					$(taxonomySelector).each(function () {
						$(this).find("option").removeClass("child-selected");
						var selectedOption = $(this).find("option:selected");
						var parentId = selectedOption.data("parent-id");
						if (parentId && parentId !== 0) {
							$(this)
								.find("option")
								.each(function () {
									if ($(this).data("term-id") === parentId) {
										$(this).addClass("child-selected");
									}
								});
						}
					});
				}

				$(taxonomySelector).on("change", function () {
					updateActiveClassOnSelect();
					updateParentClassOnChildSelect();
					fetchPosts(1);
				});

				checkFiltersSelected();
				updateActiveClassOnSelect();
				updateParentClassOnChildSelect();
				applyFiltersFromUrl();
			}

			// Usage of the function for a specific page
			initializeTaxonomyFilter({
				ajaxAction: "get_posts_by_multiple_taxonomies",
				containerSelector: "#posts-container",
				paginationSelector: "#pagination",
				taxonomySelector: ".taxonomy-select",
				searchInputSelector: "#search-input",
				sortOrderSelector: ".sort-order",
				clearFiltersSelector: ".clear-filters",
				postsPerPage: 12,
				visiblePages: 5,
				urlUpdate: false,
				dateRangeInputId: "knowledge-date-range",
				getPostCount: ".knowledge-bank-archive .post-count",
			});
			// Knowledge bank custom post archive page post filter functions - end

			// For blog
			// Usage of the function for a specific page
			initializeTaxonomyFilter({
				ajaxAction: "get_filtered_blog_posts", // Updated action name
				containerSelector: "#blog-posts-container",
				paginationSelector: "#blog-pagination",
				taxonomySelector: ".blog-taxonomy-select",
				searchInputSelector: "#blog-search-input",
				sortOrderSelector: ".blog-sort-order",
				clearFiltersSelector: ".blog-clear-filters",
				postsPerPage: 12,
				visiblePages: 5,
				urlUpdate: false,
				dateRangeInputId: "blog-date-range",
				getPostCount: ".blog-post-count",
			});

			// For research and tools
			initializeTaxonomyFilter({
				ajaxAction: "get_filtered_researchTools_posts",
				containerSelector: "#reportPosts-container",
				paginationSelector: "#reportPagination",
				taxonomySelector: ".taxonomy-select",
				searchInputSelector: "#reportSearch",
				sortOrderSelector: ".Report-sort-order",
				clearFiltersSelector: ".report-clear-filters",
				postsPerPage: 12,
				visiblePages: 5,
				urlUpdate: false,
				dateRangeInputId: "report-date-range",
				getPostCount: ".report-post-count",
			});

			// For News & Media -> Events
			initializeTaxonomyFilter({
				ajaxAction: "get_filtered_events",
				containerSelector: "#events-container",
				paginationSelector: "#eventsPagination",
				taxonomySelector: ".taxonomy-select",
				searchInputSelector: "#reportSearch",
				sortOrderSelector: ".events-sort-order",
				clearFiltersSelector: ".events-clear-filters",
				postsPerPage: 12,
				visiblePages: 5,
				urlUpdate: false,
				dateRangeInputId: "events-date-range",
				getPostCount: ".event-post-count",
			});

			// For Media coverage
			initializeTaxonomyFilter({
				ajaxAction: "get_filtered_media_coverage",
				containerSelector: "#media-coverage-posts-container",
				paginationSelector: "#media-coverage-pagination",
				taxonomySelector: ".taxonomy-select",
				searchInputSelector: "#search-input",
				sortOrderSelector: ".media-coverage-sort-order",
				clearFiltersSelector: ".media-coverage-clear-filters",
				postsPerPage: 12,
				visiblePages: 5,
				urlUpdate: false,
				dateRangeInputId: "media-coverage-date-range",
				getPostCount: ".media-coverage-post-count",
			});

			// For Press releases
			initializeTaxonomyFilter({
				ajaxAction: "get_filtered_press_releases",
				containerSelector: "#press-releases-container",
				paginationSelector: "#pressReleasesPagination",
				taxonomySelector: ".taxonomy-select",
				searchInputSelector: "#reportSearch",
				sortOrderSelector: ".press-releases-sort-order",
				clearFiltersSelector: ".press-releases-clear-filters",
				postsPerPage: 12,
				visiblePages: 5,
				urlUpdate: false,
				dateRangeInputId: "press-releases-date-range",
				getPostCount: ".press-releases-post-count",
			});
		})();
	});
});

// tab control
document.addEventListener("DOMContentLoaded", function () {
	// ----- Tabs (leave as-is if you have tabs on the page) -----
	const tabButtons = document.querySelectorAll(".tab-button");
	const tabPanes = document.querySelectorAll(".tab-content");

	if (tabButtons.length && tabPanes.length) {
		tabButtons.forEach((button) => {
			button.addEventListener("click", function () {
				const targetId = this.getAttribute("data-tab");

				tabButtons.forEach((btn) => btn.classList.remove("active"));
				this.classList.add("active");

				tabPanes.forEach((pane) => pane.classList.remove("active"));
				const targetPane = document.getElementById(targetId);
				if (targetPane) targetPane.classList.add("active");
			});
		});
	}

	// Bootstrap accordion handles its own behavior, no custom JavaScript needed
});

// Homepage impact section
//impact tab controller
class TabController {
	constructor() {
		this.tabButtons = document.querySelectorAll(".tab-nav-item");
		this.tabPanes = document.querySelectorAll(".tab-pane");
		this.loadingSpinner = document.querySelector(".loading-spinner");
		this.init();
		// Remove the disableTransformAnimations call to enable new animations
		this.setupInitialCardStates();
	}

	init() {
		this.tabButtons.forEach((button) => {
			button.addEventListener("click", (e) => {
				e.preventDefault();
				const tabId = button.getAttribute("data-tab");
				this.switchTab(tabId, button);
			});
		});

		// Add keyboard navigation
		this.tabButtons.forEach((button) => {
			button.addEventListener("keydown", (e) => {
				if (e.key === "Enter" || e.key === " ") {
					e.preventDefault();
					button.click();
				}
			});
		});
	}

	setupInitialCardStates() {
		const cards = document.querySelectorAll(".impact-card");
		cards.forEach((card) => {
			card.style.opacity = "0";
			card.style.transform = "translateY(30px)";
			card.style.transition = "all 0.6s ease";
		});
	}

	switchTab(tabId, clickedButton) {
		// Show loading spinner
		this.showLoading();

		// Hide current cards with exit animation
		this.hideCurrentCards();

		setTimeout(() => {
			// Remove active class from all buttons
			this.tabButtons.forEach((btn) => {
				btn.classList.remove("active");
			});

			// Add active class to clicked button
			clickedButton.classList.add("active");

			// Hide all tab panes
			this.tabPanes.forEach((pane) => {
				pane.classList.remove("active");
			});

			// Show selected tab pane
			const targetPane = document.getElementById(tabId);
			if (targetPane) {
				targetPane.classList.add("active");

				// Animate new cards with entrance animation
				this.animateCardsEntrance(targetPane);
			}

			// Hide loading spinner
			this.hideLoading();

			// Trigger custom event for external listeners
			this.triggerTabChangeEvent(tabId);
		}, 400);
	}

	hideCurrentCards() {
		const activePane = document.querySelector(".tab-pane.active");
		if (activePane) {
			const currentCards = activePane.querySelectorAll(".impact-card");
			currentCards.forEach((card, index) => {
				setTimeout(() => {
					// Option 1: Fade out with slide up
					card.style.opacity = "0";
					card.style.transform = "translateY(-20px)";
				}, index * 100); // Staggered exit
			});
		}
	}

	animateCardsEntrance(targetPane) {
		const newCards = targetPane.querySelectorAll(".impact-card");

		// Choose your animation style by uncommenting one of these options:

		// OPTION 1: Staggered slide up with fade
		this.animateSlideUpStaggered(newCards);

		// OPTION 2: Scale in with bounce effect
		// this.animateScaleInBounce(newCards);

		// OPTION 3: Slide in from different directions
		// this.animateSlideInDirections(newCards);

		// OPTION 4: Flip in effect
		// this.animateFlipIn(newCards);

		// OPTION 5: Wave effect
		// this.animateWaveEffect(newCards);
	}

	// Animation Option 1: Staggered slide up with fade
	animateSlideUpStaggered(cards) {
		cards.forEach((card, index) => {
			// Reset initial state
			card.style.opacity = "0";
			card.style.transform = "translateY(50px)";

			setTimeout(() => {
				card.style.opacity = "1";
				card.style.transform = "translateY(0)";
			}, index * 150 + 100); // Staggered entrance
		});
	}

	// Animation Option 2: Scale in with bounce
	animateScaleInBounce(cards) {
		cards.forEach((card, index) => {
			card.style.opacity = "0";
			card.style.transform = "scale(0.7) translateY(20px)";
			card.style.transition = "all 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)";

			setTimeout(() => {
				card.style.opacity = "1";
				card.style.transform = "scale(1) translateY(0)";
			}, index * 120 + 100);
		});
	}

	// Animation Option 3: Slide in from different directions
	animateSlideInDirections(cards) {
		const directions = [
			"translateX(-60px)",
			"translateY(60px)",
			"translateX(60px)",
		];

		cards.forEach((card, index) => {
			card.style.opacity = "0";
			card.style.transform = directions[index] || "translateY(60px)";

			setTimeout(() => {
				card.style.opacity = "1";
				card.style.transform = "translateX(0) translateY(0)";
			}, index * 100 + 150);
		});
	}

	// Animation Option 4: Flip in effect
	animateFlipIn(cards) {
		cards.forEach((card, index) => {
			card.style.opacity = "0";
			card.style.transform = "perspective(600px) rotateY(-90deg)";
			card.style.transformOrigin = "center center";

			setTimeout(() => {
				card.style.opacity = "1";
				card.style.transform = "perspective(600px) rotateY(0deg)";
			}, index * 150 + 100);
		});
	}

	// Animation Option 5: Wave effect
	animateWaveEffect(cards) {
		cards.forEach((card, index) => {
			card.style.opacity = "0";
			card.style.transform = "translateY(40px) rotateZ(-5deg)";

			setTimeout(() => {
				card.style.opacity = "1";
				card.style.transform = "translateY(0) rotateZ(0deg)";

				// Add a subtle wave motion
				setTimeout(() => {
					card.style.transform = "translateY(-5px) rotateZ(1deg)";
					setTimeout(() => {
						card.style.transform = "translateY(0) rotateZ(0deg)";
					}, 200);
				}, 300);
			}, index * 100 + 100);
		});
	}

	showLoading() {
		this.loadingSpinner.style.display = "flex";
		this.tabPanes.forEach((pane) => {
			pane.style.opacity = "0.3";
		});
	}

	hideLoading() {
		this.loadingSpinner.style.display = "none";
		this.tabPanes.forEach((pane) => {
			pane.style.opacity = "1";
		});
	}

	triggerTabChangeEvent(tabId) {
		const event = new CustomEvent("tabChanged", {
			detail: { tabId: tabId },
		});
		document.dispatchEvent(event);
	}

	// Public method to programmatically switch tabs
	switchToTab(tabId) {
		const button = document.querySelector(`[data-tab="${tabId}"]`);
		if (button) {
			this.switchTab(tabId, button);
		}
	}

	// Public method to get current active tab
	getCurrentTab() {
		const activeButton = document.querySelector(".tab-nav-item.active");
		return activeButton ? activeButton.getAttribute("data-tab") : null;
	}
}

// Initialize tab controller when DOM is loaded
document.addEventListener("DOMContentLoaded", () => {
	const tabController = new TabController();

	// Example: Listen for tab changes
	document.addEventListener("tabChanged", (e) => {
		console.log("Tab changed to:", e.detail.tabId);
	});

	// Animate initial cards on page load
	setTimeout(() => {
		const initialCards = document.querySelectorAll(
			".tab-pane.active .impact-card"
		);
		initialCards.forEach((card, index) => {
			setTimeout(() => {
				card.style.opacity = "1";
				card.style.transform = "translateY(0)";
			}, index * 150 + 500);
		});
	}, 100);
});

//# sourceMappingURL=theme.js.map
